import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import "../Styles/Order.css";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";
import Item from "../containers/_Item";
import EGiftCardItem from "../containers/_EGiftCardItem";
import RecommendedItems from "../containers/_RecommendedItems";
import Arrow from "./_Arrow";
import CancelOrderWindow from "../containers/_CancelOrderWindow";
import CancelOrderItemsWindow from "../containers/_CancelOrderItemsWindow";
import ReturnOrderWindow from "../containers/_ReturnOrderWindow";
import ReturnOrderItemsWindow from "../containers/_ReturnOrderItemsWindow";
import InvoiceWindow from "../containers/_InvoiceWindow";
import EgiftCardsEmailWindow from "../containers/_EgiftCardsEmailWindow";
import locales from "../../../_constants/locales";
import OrderFetchErrorPage from "../containers/_OrderFetchErrorPage";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import { trackEvent } from "../../../_utils/GoogleAnalytics";
import "moment/locale/fr";
import "moment/locale/es";
import "moment/locale/pt";
import "moment/locale/it";
import "moment/locale/de";
import "moment/locale/nl";

class Order extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cancel_order_window_open: false,
            cancel_items_window_open: false,
            invoice_window_open: false,
            return_order_window_open: false,
            return_items_window_open: false,
            replace_window_open: false,
            replace_items_window_open: false,
            egiftcards_email_window_open: false
        };
    }

    getViewQueryParameters() {
        let search = this.props.location.search;

        if (search) {
            let params = search.substring(1, search.length).split("&");

            var store = [];

            for (let index = 0; index < params.length; index++) {
                let q = params[index].split("=");

                if (q[0].toUpperCase() === "STORE" && q[1] !== "") {
                    q[1]
                        .toUpperCase()
                        .split(",")
                        .forEach(e => {
                            if (this.props.store_list.indexOf(e) >= 0) {
                                store.push(e);
                            }
                        });
                } else if (q[0].toUpperCase() === "LANGUAGE" && q[1] !== "") {
                    if (this.props.language_list.indexOf(q[1].toUpperCase()) >= 0) {
                        this.props.setLanguage(q[1].toUpperCase());
                    }
                }
            }

            if (store.length > 0) {
                this.props.setStore(store);
            }
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.postMessageToParentWindow.bind(this));
        trackEvent("Order", "View Order", "true");

        this.props.resetLanguage();
        this.props.resetStore();
        this.props.reset();

        if (this.props.language_list.length === 0) {
            this.props.getLanguages();
        }

        if (this.props.store_list.length === 0) {
            this.props.getStores();
        }

        this.getViewQueryParameters();

        this.postMessageToParentWindow();
        this.props.get(this.props.match.params.order_id);
        moment.locale(this.props.language);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.postMessageToParentWindow();

        if (prevProps.language !== this.props.language) {
            moment.locale(this.props.language);
        }

        if (this.props.language_list !== prevProps.language_list || this.props.store_list !== prevProps.store_list) {
            this.getViewQueryParameters();
        }

        if (this.props.egift_cards_email_loading === false && prevProps.egift_cards_email_loading === true) {
            if (!this.props.err) {
                this.setState({
                    cancelFinished: true
                });
            }
        }

        this.postMessageToParentWindow();
    }

    postMessageToParentWindow() {
        let rootElement = document.getElementById("root");
        let height = Math.max(rootElement.scrollHeight, rootElement.offsetHeight, rootElement.clientHeight);

        let data = {
            action: "SITE_UPDATED",
            height
        };
        window.parent.window.postMessage(JSON.stringify(data), "*");
    }

    subOrderIsCancelled(sub_order) {
        return sub_order !== null && sub_order.order_statuses !== null && sub_order.order_statuses.some(os => os.status === "CANCELLED" && os.date);
    }

    orderIsCancelled() {
        return this.props.order.cancelled_at !== null;
    }

    subOrderIsShipped(sub_order) {
        return sub_order !== null && sub_order.order_statuses !== null && sub_order.order_statuses.some(os => os.status === "SHIPPED" && os.date);
    }

    subOrderIsRefunded(sub_order) {
        return sub_order !== null && sub_order.order_statuses !== null && sub_order.order_statuses.some(os => os.status === "REFUNDED" && os.date);
    }

    subOrderIsCompleted(sub_order) {
        return !sub_order.order_statuses.some(os => os.show === true && os.date === null);
    }

    getCompleteOrderStatus() {
        if (this.props.order.sub_orders.every(so => so.order_statuses.some(os => os.status === "REFUNDED" && os.date && os.show))) {
            return "Refunded";
        } else if (this.props.order.sub_orders.every(so => so.order_statuses.some(os => os.status === "DELIVERED" && os.date && os.show))) {
            return "Delivered";
        }
        return null;
    }

    handleGoBackToSearch() {
        trackEvent("Order", "Back To Search", "true");
        this.props.history.push(`/embedded/search?store=${this.props.store}&language=${this.props.language}`);
    }

    refreshOrder() {
        this.props.get(this.props.match.params.order_id);
        this.props.reset();
    }

    getSubOrders() {
        return this.props.order.sub_orders;
    }

    isCurrentStatus(order_status, order_statuses) {
        return (
            order_status.show &&
            order_statuses.some(os => !os.date && os.show) &&
            order_statuses.filter(os => !os.date && os.show)[0].status === order_status.status
        );
    }

    isNextStatus(order_status, order_statuses) {
        return (
            order_statuses.filter(os => os.show).indexOf(order_status) > 1 &&
            this.isCurrentStatus(order_statuses[order_statuses.filter(os => os.show).indexOf(order_status) - 1], order_statuses)
        );
    }

    isLastStatus(order_status, order_statuses) {
        return order_statuses.filter(os => os.show).indexOf(order_status) === order_statuses.filter(os => os.show).length - 1;
    }

    isSecondLastStatus(order_status, order_statuses) {
        return order_statuses.filter(os => os.show).indexOf(order_status) === order_statuses.filter(os => os.show).length - 2;
    }

    isPreviousStatus(order_status, order_statuses) {
        return (
            this.isCurrentStatus(order_statuses[order_statuses.filter(os => os.show).indexOf(order_status) + 2], order_statuses) ||
            (order_statuses.every(os => os.show && os.date) &&
                order_statuses.filter(os => os.show)[0].indexOf(order_status) === order_statuses.filter(os => os.show).length - 2)
        );
    }

    isClosedStatus(order_status, order_statuses) {
        if (order_statuses.some(os => this.isCurrentStatus(os, order_statuses))) {
            var current_index = order_statuses.filter(os => os.show).indexOf(order_statuses.filter(os => this.isCurrentStatus(os, order_statuses))[0]);

            if (
                (!this.isSecondLastStatus(order_status, order_statuses) &&
                    order_statuses.filter(os => os.show).indexOf(order_statuses.filter(os => os.show).filter(os => os === order_status)[0]) < current_index) ||
                order_statuses.some(
                    os =>
                        order_statuses.filter(os => os.show).indexOf(order_statuses.filter(os => os.show).filter(oss => oss === order_status)[0]) >
                        current_index + 1
                )
            ) {
                return true;
            }
        } else {
            if (
                order_statuses.filter(os => os.show).indexOf(order_statuses.filter(os => os === order_status)[0]) <
                order_statuses.filter(os => os.show).length - 2
            ) {
                return true;
            }
        }

        return false;
    }

    getCurrentSubOrderStatus(sub_order) {
        var current_status = sub_order.order_statuses.filter(order_status => this.isCurrentStatus(order_status, sub_order.order_statuses))[0];

        return current_status;
    }

    getSubOrderItems(sub_order) {
        var sub_order_line_items = [];

        if (this.props.order.refunded_items) {
            sub_order.line_items.forEach(line_item => {
                if (this.props.order.refunded_items.filter(ri => ri.id === line_item.id)[0]) {
                    var refunded_item = this.props.order.refunded_items.filter(ri => ri.id === line_item.id)[0];

                    if (line_item.quantity > 1 && line_item.quantity > refunded_item.quantity) {
                        let temp_line_item = JSON.parse(JSON.stringify(line_item));
                        temp_line_item.quantity = line_item.quantity - refunded_item.quantity;
                        sub_order_line_items.push(temp_line_item);
                    }
                } else {
                    sub_order_line_items.push(line_item);
                }
            });
        } else {
            sub_order_line_items = sub_order.line_items;
        }

        return sub_order_line_items;
    }

    getProtectionItems() {
        if (this.props.order && this.props.order.line_items) {
            return _.orderBy(
                this.props.order.line_items.filter(li => li.requires_shipping === false && !li.sku.includes("EGIFTCARD")),
                ["price"],
                ["desc"]
            );
        } else {
            return [];
        }
    }

    getNonProtectionItems() {
        if (this.props.order && this.props.order.line_items) {
            return _.orderBy(
                this.props.order.line_items.filter(li => li.requires_shipping === true),
                ["price"],
                ["desc"]
            );
        } else {
            return [];
        }
    }

    getCalculatedProtectionItems() {
        var protectionLineItems = [];

        if (this.props.order && this.props.order.line_items) {
            if (this.props.order.refunded_items) {
                this.props.order.line_items
                    .filter(li => li.requires_shipping === false && !li.sku.includes("EGIFTCARD"))
                    .forEach(line_item => {
                        if (this.props.order.refunded_items.filter(ri => ri.id === line_item.id)[0]) {
                            var refunded_item = this.props.order.refunded_items.filter(ri => ri.id === line_item.id)[0];

                            if (line_item.quantity > 1 && line_item.quantity > refunded_item.quantity) {
                                let temp_line_item = JSON.parse(JSON.stringify(line_item));
                                temp_line_item.quantity = line_item.quantity - refunded_item.quantity;
                                protectionLineItems.push(temp_line_item);
                            }
                        } else {
                            protectionLineItems.push(line_item);
                        }
                    });
            } else {
                protectionLineItems = this.props.order.line_items.filter(li => li.requires_shipping === false && !li.sku.includes("EGIFTCARD"));
            }
        }

        return _.orderBy(protectionLineItems, ["price"], ["desc"]);
    }

    getOrderItems() {
        return this.props.order.line_items;
    }

    getRefundedItems() {
        return this.props.order.refunded_items;
    }

    // getFooter() {
    //     return (
    //         (this.props.order.cancel_order_enabled && (
    //             <div className="layout vertical footer">
    //                 <CancelOrderWindow
    //                     order={this.props.order}
    //                     open={this.state.cancel_window_open}
    //                     order_id={this.props.match.params.order_id}
    //                     handleCloseCancelOrderDialog={this.handleCloseCancelOrderDialog.bind(this)}
    //                 />
    //             </div>
    //         )
    //     );
    // }

    handleCancelOrderClick() {
        this.handleOpenCancelOrderDialog();
    }

    handleCancelOrderItemsClick() {
        this.handleOpenCancelOrderItemsDialog();
    }

    handleOpenCancelOrderDialog() {
        trackEvent("Order", "Cancel Order Confirmation Window", "true");
        this.setState({
            cancel_order_window_open: true
        });
    }

    handleOpenCancelOrderItemsDialog() {
        trackEvent("Order", "Cancel Order Confirmation Window", "true");
        this.setState({
            cancel_items_window_open: true
        });
    }

    handleCloseCancelOrderDialog() {
        this.setState({
            cancel_order_window_open: false
        });
    }

    handleCloseCancelOrderItemsDialog() {
        this.setState({
            cancel_items_window_open: false
        });
    }

    handleReturnOrderClick() {
        this.handleOpenReturnOrderDialog();
    }

    handleReturnOrderItemsClick() {
        this.handleOpenReturnOrderItemsDialog();
    }

    handleRequestAssistanceClick() {
        window.open(locales[this.props.store[0]][this.props.language].MISC.HELP_LINK, "_blank");
    }

    handleOpenReturnOrderDialog() {
        trackEvent("Order", "Return Order Confirmation Window", "true");
        this.setState({
            return_order_window_open: true
        });
    }

    handleOpenReturnOrderItemsDialog() {
        trackEvent("Order", "Return Order Confirmation Window", "true");
        this.setState({
            return_items_window_open: true
        });
    }

    handleCloseReturnOrderDialog() {
        this.setState({
            return_order_window_open: false
        });
    }

    handleCloseReturnOrderItemsDialog() {
        this.setState({
            return_items_window_open: false
        });
    }

    handleReplaceOrderItemsClick() {
        this.handleOpenReplaceOrderItemsDialog();
    }

    handleOpenReplaceOrderItemsDialog() {
        trackEvent("Order", "Replace Order Confirmation Window", "true");
        this.setState({
            replace_items_window_open: true
        });
    }

    handleCloseReplaceOrderItemsDialog() {
        this.setState({
            replace_items_window_open: false
        });
    }

    handleGenerateInvoiceClick() {
        this.handleOpenInvoiceDialog();
    }

    handleOpenInvoiceDialog() {
        this.setState({
            invoice_window_open: true
        });
    }

    handleCloseInvoiceDialog() {
        this.setState({
            invoice_window_open: false
        });
    }

    handleSendEgiftcardsEmailClick() {
        this.handleOpenEgiftCardsEmailDialog();
    }

    handleOpenEgiftCardsEmailDialog() {
        this.setState({
            egiftcards_email_window_open: true
        });
    }

    handleCloseEgiftCardsEmailDialog() {
        this.setState({
            egiftcards_email_window_open: false
        });
    }

    getFetchFailed() {
        return <OrderFetchErrorPage />;
    }

    subOrderIsFullyRefunded() {
        return this.props.order.sub_orders.every(so => so.order_statuses.some(os => os.status === "REFUNDED" && os.show));
    }

    orderIsFullyRefunded() {
        return this.props.order.fully_refunded;
    }

    handleTrack(fulfillment) {
        trackEvent("Order", "Track Order Shipment", "true");
        window.open(fulfillment.tracking_url, "_blank");
    }

    getRecommendedItems() {
        return <RecommendedItems />;
    }

    showFullOrderTrackingInformation() {
        let visible_sub_orders = this.getVisibleSubOrders();

        return !this.orderIsCancelled() && !this.orderIsFullyRefunded() && visible_sub_orders && visible_sub_orders.length === 1;
    }

    getVisibleSubOrders() {
        let sub_orders = this.getSubOrders();

        if (sub_orders) {
            sub_orders = sub_orders.filter(sub_order => this.getSubOrderItems(sub_order).length > 0);
        }

        return sub_orders;
    }

    sortItems(items) {
        let sortedItems = [];

        let itemsCopy = JSON.parse(JSON.stringify(items));

        itemsCopy.forEach(item => {
            item.price = parseFloat(item.price);
        });

        itemsCopy = _.orderBy(itemsCopy, ["price", "sku"], ["desc", "asc"]);

        itemsCopy.forEach(item => {
            if (item.requires_shipping === true) {
                sortedItems.push(item);

                let protectionItems = itemsCopy.filter(
                    i => i.title.includes("Protection") && i.properties.some(p => p.name === "Reference" && p.value === item.variant_id.toString())
                );

                if (protectionItems) {
                    sortedItems = sortedItems.concat(protectionItems);
                }
            }
        });

        let protectionItemsNotAllocated = itemsCopy.filter(
            i => i.title.includes("Protection") && !i.sku.includes("EGIFTCARD") && !sortedItems.some(sortedItem => sortedItem.id == i.id)
        );

        if (protectionItemsNotAllocated && protectionItemsNotAllocated.length > 0) {
            sortedItems = sortedItems.concat(protectionItemsNotAllocated);
        }

        return sortedItems;
    }

    sortModifiedItems(items) {
        let normalSortedList = this.sortItems(this.props.order.line_items);
        let sortedItems = [];
        let itemsCopy = JSON.parse(JSON.stringify(items));
        itemsCopy.forEach(item => {
            item.price = parseFloat(item.price);
        });

        normalSortedList.forEach(normalSorteditem => {
            var item = items.filter(i => i.id === normalSorteditem.id)[0];
            if (item) {
                sortedItems.push(item);
            }
        });

        return sortedItems;
    }

    render() {
        let refunded_items = this.getRefundedItems();
        let sub_orders = this.getVisibleSubOrders();
        let protectionLineItems = this.getProtectionItems();
        let nonProtectionLineItems = this.getNonProtectionItems();
        let calculatedProtectionLineItems = this.getCalculatedProtectionItems();

        return (
            <section
                className={`flex layout horizontal center-justified${
                    this.state.cancel_order_window_open ||
                    this.state.cancel_items_window_open ||
                    this.state.invoice_window_open ||
                    this.state.return_order_window_open ||
                    this.state.return_items_window_open ||
                    this.state.replace_items_window_open ||
                    this.state.egiftcards_email_window_open
                        ? " in-background"
                        : ""
                }`}
            >
                {this.props.loading || this.props.language_list_loading || this.props.store_list_loading ? (
                    <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                ) : _.isEmpty(this.props.order) || this.props.fetching_error ? (
                    this.getFetchFailed()
                ) : (
                    <div
                        className={`flex order-main${
                            this.state.cancel_order_window_open ||
                            this.state.cancel_items_window_open ||
                            this.state.invoice_window_open ||
                            this.state.return_order_window_open ||
                            this.state.return_items_window_open ||
                            this.state.replace_items_window_open ||
                            this.state.egiftcards_email_window_open
                                ? " in-background"
                                : ""
                        }`}
                    >
                        <div className="header">
                            <div className="layout horizontal">
                                <a className={`layout horizontal center back-to-search linked-text`} onClick={this.handleGoBackToSearch.bind(this)}>
                                    <NavigateBeforeIcon style={{ fontSize: "22px", height: "20px", width: "20px" }} />
                                    {`${locales[this.props.store[0]][this.props.language].ORDER_PAGE.HEADER_SECTION.BACK_TO_SEARCH}`}
                                </a>
                            </div>
                            <div className="layout sub-header justified">
                                <div className="layout vertical">
                                    <div className="layout horizontal order-name-box">
                                        <h1 className="title">{this.props.order.name}</h1>
                                        <div className="layout horizontal order-tags center">
                                            {this.props.order.preorder && (
                                                <div className="tag">{locales[this.props.store[0]][this.props.language].MISC.PREORDER}</div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="layout justified order-date-pre-order">
                                        <p className="order-date">{`${
                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.HEADER_SECTION.ORDERED_ON
                                        } ${moment(new Date(this.props.order.created_at)).format("LL")}`}</p>
                                    </div>
                                </div>
                                <div className="layout horizontal end order-menu-buttons">
                                    {this.props.order.invoice_enabled && (
                                        <button className="order-menu-button" onClick={this.handleGenerateInvoiceClick.bind(this)}>
                                            {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.INVOICE}
                                        </button>
                                    )}
                                    <div className="vertical-spacer-5" />
                                    {this.props.order.cancel_order_enabled &&
                                        (this.props.order.cancel_order_items_enabled ? (
                                            <button className="order-menu-button" onClick={this.handleCancelOrderItemsClick.bind(this)}>
                                                {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.CANCEL_ITEMS}
                                            </button>
                                        ) : (
                                            <button className="order-menu-button" onClick={this.handleCancelOrderClick.bind(this)}>
                                                {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.CANCEL_ORDER}
                                            </button>
                                        ))}
                                    {this.props.order.return_order_enabled &&
                                        (this.props.order.return_order_items_enabled ? (
                                            <button className="order-menu-button" onClick={this.handleReturnOrderItemsClick.bind(this)}>
                                                {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.RETURN_ITEMS}
                                            </button>
                                        ) : (
                                            <button className="order-menu-button" onClick={this.handleReturnOrderClick.bind(this)}>
                                                {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.RETURN_ORDER}
                                            </button>
                                        ))}
                                    {/* {this.props.order.replace_order_items_enabled && (
                                            <button className="order-menu-button" onClick={this.handleReplaceOrderItemsClick.bind(this)}>
                                                {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.REPLACE_ITEMS}
                                            </button>
                                        )} */}
                                    <button className="order-menu-button" onClick={this.handleRequestAssistanceClick.bind(this)}>
                                        {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.REQUEST_ASSISTANCE}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="divider" />
                        <div className="shipping-tracking-order-summary layout horizontal">
                            <div className="flex-4 layout vertical">
                                <div>
                                    <h2 className="title">
                                        {locales[this.props.store[0]][this.props.language].ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.SHIPPING.HEADING}
                                    </h2>
                                    <div className="layout vertical flex shipping-and-tracking-details">
                                        {`${this.props.order.shipping_address.first_name} ${this.props.order.shipping_address.last_name}`}
                                        <br />
                                        {`${this.props.order.shipping_address.address1} ${this.props.order.shipping_address.address2}`}
                                        <br />
                                        {`${this.props.order.shipping_address.city}, ${
                                            this.props.order.shipping_address.province ? this.props.order.shipping_address.province : ""
                                        }  ${this.props.order.shipping_address.zip}, ${this.props.order.shipping_address.country}`}
                                    </div>
                                </div>
                                {this.showFullOrderTrackingInformation() && (
                                    <div className="layout vertical delivery-method">
                                        <h2 className="title">
                                            {
                                                locales[this.props.store[0]][this.props.language].ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.TRACKING
                                                    .HEADING
                                            }
                                        </h2>

                                        {sub_orders[0] &&
                                        sub_orders[0].fulfillment &&
                                        sub_orders[0].fulfillment.tracking_company &&
                                        sub_orders[0].fulfillment.tracking_number ? (
                                            <div className="delivery-method-info">
                                                <p>
                                                    {sub_orders[0].fulfillment.tracking_company}: {sub_orders[0].fulfillment.tracking_number}
                                                </p>
                                                <a
                                                    className={`layout horizontal center track-button linked-text`}
                                                    onClick={this.handleTrack.bind(this, sub_orders[0].fulfillment)}
                                                >
                                                    {`${
                                                        locales[this.props.store[0]][this.props.language].ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION
                                                            .TRACKING.TRACKING_BUTTON_MESSAGE
                                                    }`}
                                                    <NavigateNextIcon style={{ fontSize: "22px", height: "20px", width: "20px" }} />
                                                </a>
                                            </div>
                                        ) : (
                                            <div>
                                                {
                                                    locales[this.props.store[0]][this.props.language].ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION
                                                        .TRACKING.SHIPMENT_PENDING_MESSAGE
                                                }
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="flex-2 layout vertical order-summary">
                                <div className="flex layout horizontal">
                                    <h2 className="title flex">
                                        {
                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.ORDER_SUMMARY
                                                .HEADING
                                        }
                                    </h2>
                                </div>
                                <div className="layout horizontal justified">
                                    <div className="order-summary-headings">
                                        {`${
                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.ORDER_SUMMARY
                                                .ITEMS_SUBTOTAL_TITLE
                                        }:`}
                                        <br />
                                        {this.props.order.total_discounts > 0 ? (
                                            `${
                                                locales[this.props.store[0]][this.props.language].ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION
                                                    .ORDER_SUMMARY.DISCOUNT_TITLE
                                            }:`
                                        ) : (
                                            <br className="filler-line" />
                                        )}
                                        {this.props.order.total_discounts > 0 && <br />}
                                        {`${
                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.ORDER_SUMMARY
                                                .SHIPPING_TITLE
                                        }:`}
                                        <br />
                                        {`${
                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.ORDER_SUMMARY
                                                .TAXES_TITLE
                                        }:`}
                                        <br />
                                        {this.props.order.total_refunded > 0 ? (
                                            `${
                                                locales[this.props.store[0]][this.props.language].ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION
                                                    .ORDER_SUMMARY.REFUND_TITLE
                                            }:`
                                        ) : (
                                            <br className="filler-line" />
                                        )}
                                        {this.props.order.total_refunded > 0 && <br />}
                                        <br className="filler-line" />
                                        {`${
                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.ORDER_SUMMARY
                                                .GRAND_TOTAL_TITLE
                                        }:`}
                                    </div>
                                    <div className="order-summary-numbers">
                                        {this.props.order.total_line_items_price_formatted}
                                        <br />

                                        {this.props.order.total_discounts > 0 ? (
                                            `-${this.props.order.total_discounts > 0 ? this.props.order.total_discounts_formatted : 0}`
                                        ) : (
                                            <br className="filler-line" />
                                        )}
                                        {this.props.order.total_discounts > 0 && <br />}

                                        {this.props.order.total_shipping_formatted}
                                        <br />

                                        {this.props.order.total_tax_formatted}
                                        <br />

                                        {this.props.order.total_refunded > 0 ? `-${this.props.order.total_refunded_formatted}` : <br className="filler-line" />}
                                        {this.props.order.total_refunded > 0 && <br />}
                                        <br className="filler-line" />
                                        <p className="total-price">{this.props.order.total_price_formatted}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.props.order.rma_requests &&
                            this.props.order.rma_requests.map(rma_request => (
                                <div className="layout horizontal">
                                    <div>{`${locales[this.props.store[0]][this.props.language].ORDER_PAGE.RMA_TITLE} `}</div>&nbsp;
                                    <a
                                        className="layout horizontal center rma-link linked-text"
                                        href={`${process.env.REACT_APP_RMA_CUSTOMER_STATUS_BASE_URL}?id=${rma_request.public_ticket_id}`}
                                        target="_blank"
                                    >
                                        {rma_request.ticket_no}
                                        <NavigateNextIcon style={{ fontSize: "22px", height: "20px", width: "20px" }} />
                                    </a>
                                </div>
                            ))}
                        {this.orderIsCancelled() && (
                            <div className="cancelled-section">
                                {`${locales[this.props.store[0]][this.props.language].ORDER_PAGE.CANCELLED_SECTION.CANCELLED_MESSAGE} `}
                                {moment(new Date(this.props.order.cancelled_at)).format("LL")}
                            </div>
                        )}
                        {!this.orderIsCancelled() && this.orderIsFullyRefunded() && (
                            <div className="cancelled-section">
                                {`${locales[this.props.store[0]][this.props.language].ORDER_PAGE.REFUNDED_SECTION.REFUNDED_MESSAGE} `}
                            </div>
                        )}
                        {!this.orderIsCancelled() &&
                            !this.orderIsFullyRefunded() &&
                            sub_orders.map((sub_order, i) => {
                                let sub_order_line_items = this.getSubOrderItems(sub_order);

                                return (
                                    <div key={i}>
                                        {!this.subOrderIsCancelled(sub_order) &&
                                            this.getCurrentSubOrderStatus(sub_order) &&
                                            this.getCurrentSubOrderStatus(sub_order).status === "AUTHORIZED" && (
                                                <div>
                                                    <div className="authorized-section">
                                                        {`* ${
                                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.AUTHORIZED_SECTION.AUTHORIZED_MESSAGE
                                                        }`}
                                                    </div>
                                                </div>
                                            )}

                                        <div className="layout horizontal status-bar">
                                            {sub_order.order_statuses
                                                .filter(order_status => order_status.show)
                                                .map((order_status, ii) => {
                                                    let isCurrent =
                                                        !this.subOrderIsCompleted(sub_order) && this.isCurrentStatus(order_status, sub_order.order_statuses);
                                                    let arrowLabel = isCurrent
                                                        ? locales[this.props.store[0]][this.props.language].ORDER_PAGE.STATUS_BAR_SECTION.STATUSES[
                                                              order_status.status
                                                          ].ACTIVE
                                                        : locales[this.props.store[0]][this.props.language].ORDER_PAGE.STATUS_BAR_SECTION.STATUSES[
                                                              order_status.status
                                                          ].COMPLETED;

                                                    return (
                                                        <Arrow
                                                            key={ii}
                                                            order_status={order_status}
                                                            label={arrowLabel}
                                                            position={ii + 1}
                                                            current={isCurrent}
                                                            next={this.isNextStatus(order_status, sub_order.order_statuses)}
                                                            previous={this.isPreviousStatus(order_status, sub_order.order_statuses)}
                                                            second_last={this.isSecondLastStatus(order_status, sub_order.order_statuses)}
                                                            last={this.isLastStatus(order_status, sub_order.order_statuses)}
                                                            closed={this.isClosedStatus(order_status, sub_order.order_statuses)}
                                                            dimmed={
                                                                this.subOrderIsCompleted(sub_order) &&
                                                                !this.isLastStatus(order_status, sub_order.order_statuses)
                                                            }
                                                            date={order_status.date}
                                                        />
                                                    );
                                                })}
                                        </div>
                                        {!this.showFullOrderTrackingInformation() && (
                                            <div className="layout vertical delivery-method">
                                                <h2 className="title">
                                                    {
                                                        locales[this.props.store[0]][this.props.language].ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION
                                                            .TRACKING.HEADING
                                                    }
                                                </h2>

                                                {sub_order.fulfillment && sub_order.fulfillment.tracking_company && sub_order.fulfillment.tracking_number ? (
                                                    <div className="delivery-method-info">
                                                        <p>
                                                            {sub_order.fulfillment.tracking_company}: {sub_order.fulfillment.tracking_number}
                                                        </p>
                                                        <p className="track-button" onClick={this.handleTrack.bind(this, sub_order.fulfillment)}>
                                                            {`${
                                                                locales[this.props.store[0]][this.props.language].ORDER_PAGE
                                                                    .SHIPPING_TRACKING_ORDER_SUMMARY_SECTION.TRACKING.TRACKING_BUTTON_MESSAGE
                                                            } >`}
                                                        </p>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        {
                                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.SHIPPING_TRACKING_ORDER_SUMMARY_SECTION
                                                                .TRACKING.SHIPMENT_PENDING_MESSAGE
                                                        }
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        <div className="order-items">
                                            {sub_order_line_items.map((item, i) => {
                                                if (i % 2 === 0) {
                                                    return (
                                                        <div className="layout horizontal items-row" key={i}>
                                                            {<Item key={i} item={this.sortModifiedItems(sub_order_line_items)[i]} order={this.props.order} />}
                                                            {this.sortModifiedItems(sub_order_line_items)[i + 1] && (
                                                                <Item
                                                                    key={i + 1}
                                                                    item={this.sortModifiedItems(sub_order_line_items)[i + 1]}
                                                                    order={this.props.order}
                                                                />
                                                            )}
                                                        </div>
                                                    );
                                                }
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                        {/* if order is not fully refunded, list all protection items items */}
                        {!this.orderIsFullyRefunded() && calculatedProtectionLineItems.length > 0 && (
                            <div className="layout vertical">
                                <h2 className="title">{locales[this.props.store[0]][this.props.language].ORDER_PAGE.ITEMS_SECTION.PROTECTION.TITLE}</h2>
                                <div className="horizontal-separator-inner-fade" />
                                <div className="order-items">
                                    {calculatedProtectionLineItems.map((item, i) => {
                                        if (i % 2 === 0) {
                                            return (
                                                <div className="layout horizontal items-row" key={i}>
                                                    {<Item key={i} item={this.sortModifiedItems(calculatedProtectionLineItems)[i]} order={this.props.order} />}
                                                    {this.sortModifiedItems(calculatedProtectionLineItems)[i + 1] && (
                                                        <Item
                                                            key={i + 1}
                                                            item={this.sortModifiedItems(calculatedProtectionLineItems)[i + 1]}
                                                            order={this.props.order}
                                                        />
                                                    )}
                                                </div>
                                            );
                                        }
                                    })}
                                </div>
                            </div>
                        )}
                        {/* if order is not fully refunded, list all eGift Cards */}
                        {!this.orderIsFullyRefunded() && this.props.order.egift_cards && this.props.order.egift_cards.length > 0 && (
                            <div className="layout vertical">
                                <div className="layout horizontal">
                                    <h2 className="flex title">
                                        {locales[this.props.store[0]][this.props.language].ORDER_PAGE.ITEMS_SECTION.EGIFTCARDS.TITLE}
                                    </h2>
                                    <div className="order-menu-buttons" style={{ marginTop: "8px" }}>
                                        <div
                                            onClick={this.handleSendEgiftcardsEmailClick.bind(this)}
                                            className="layout horizontal center justified order-menu-button"
                                        >
                                            {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.SEND_EGIFTCARDS_EMAIL}
                                        </div>
                                    </div>
                                </div>
                                <div className="horizontal-separator-inner-fade" />
                                <div className="order-items">
                                    {this.props.order.egift_cards.map((egiftCard, i) => {
                                        if (i % 2 === 0) {
                                            return (
                                                <div className="layout horizontal items-row" key={i}>
                                                    {<EGiftCardItem key={i} item={egiftCard} order={this.props.order} />}
                                                    {this.props.order.egift_cards[i + 1] && (
                                                        <EGiftCardItem key={i + 1} item={this.props.order.egift_cards[i + 1]} order={this.props.order} />
                                                    )}
                                                </div>
                                            );
                                        }
                                    })}
                                </div>
                            </div>
                        )}
                        {/* if order is cancelled and fully refunded, list all non protection items and all protection items and all egift cards */}
                        {(this.orderIsCancelled() || this.orderIsFullyRefunded()) && (
                            <div className="order-items">
                                {nonProtectionLineItems.map((item, i) => {
                                    if (i % 2 === 0) {
                                        return (
                                            <div className="layout horizontal items-row" key={i}>
                                                {<Item key={i} item={this.sortModifiedItems(nonProtectionLineItems)[i]} order={this.props.order} />}
                                                {this.sortModifiedItems(nonProtectionLineItems)[i + 1] && (
                                                    <Item key={i + 1} item={this.sortModifiedItems(nonProtectionLineItems)[i + 1]} order={this.props.order} />
                                                )}
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        )}
                        {(this.orderIsCancelled() || this.orderIsFullyRefunded()) && protectionLineItems.length > 0 && (
                            <div className="layout vertical">
                                <h2 className="title">{locales[this.props.store[0]][this.props.language].ORDER_PAGE.ITEMS_SECTION.PROTECTION.TITLE}</h2>
                                <div className="horizontal-separator-inner-fade" />
                                <div className="order-items">
                                    {protectionLineItems.map((item, i) => {
                                        if (i % 2 === 0) {
                                            return (
                                                <div className="layout horizontal items-row" key={i}>
                                                    {<Item key={i} item={this.sortModifiedItems(protectionLineItems)[i]} order={this.props.order} />}
                                                    {this.sortModifiedItems(protectionLineItems)[i + 1] && (
                                                        <Item key={i + 1} item={this.sortModifiedItems(protectionLineItems)[i + 1]} order={this.props.order} />
                                                    )}
                                                </div>
                                            );
                                        }
                                    })}
                                </div>
                            </div>
                        )}
                        {(this.orderIsCancelled() || this.orderIsFullyRefunded()) &&
                            this.props.order.egift_cards &&
                            this.props.order.egift_cards.length > 0 && (
                                <div className="layout vertical">
                                    <div className="layout horizontal">
                                        <h2 className="flex title">
                                            {locales[this.props.store[0]][this.props.language].ORDER_PAGE.ITEMS_SECTION.EGIFTCARDS.TITLE}
                                        </h2>
                                        <div className="order-menu-buttons" style={{ marginTop: "8px" }}>
                                            <div
                                                onClick={this.handleSendEgiftcardsEmailClick.bind(this)}
                                                className="layout horizontal center justified order-menu-button"
                                            >
                                                {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.SEND_EGIFTCARDS_EMAIL}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="horizontal-separator-inner-fade" />
                                    <div className="order-items">
                                        {this.props.order.egift_cards.map((egiftCard, i) => {
                                            if (i % 2 === 0) {
                                                return (
                                                    <div className="layout horizontal items-row" key={i}>
                                                        {<EGiftCardItem key={i} item={egiftCard} order={this.props.order} />}
                                                        {this.props.order.egift_cards[i + 1] && (
                                                            <EGiftCardItem key={i + 1} item={this.props.order.egift_cards[i + 1]} order={this.props.order} />
                                                        )}
                                                    </div>
                                                );
                                            }
                                        })}
                                    </div>
                                </div>
                            )}
                        {/* if order is not cancelled and not fully refunded, list all refund items */}
                        {!this.orderIsCancelled() && !this.orderIsFullyRefunded() && refunded_items.length > 0 && (
                            <div className="layout vertical">
                                <h2 className="title">{locales[this.props.store[0]][this.props.language].ORDER_PAGE.ITEMS_SECTION.REFUNDED.TITLE}</h2>
                                <div className="horizontal-separator-inner-fade" />
                                <div className="order-items">
                                    {refunded_items.map((item, i) => {
                                        if (i % 2 === 0) {
                                            return (
                                                <div className="layout horizontal items-row" key={i}>
                                                    {<Item key={i} item={this.sortModifiedItems(refunded_items)[i]} order={this.props.order} />}
                                                    {this.sortModifiedItems(refunded_items)[i + 1] && (
                                                        <Item key={i + 1} item={this.sortModifiedItems(refunded_items)[i + 1]} order={this.props.order} />
                                                    )}
                                                </div>
                                            );
                                        }
                                    })}
                                </div>
                            </div>
                        )}
                        <div className="order-menu-buttons-panel">
                            {this.props.order.invoice_enabled && (
                                <div
                                    onClick={this.handleGenerateInvoiceClick.bind(this)}
                                    className="layout horizontal center justified order-menu-button-panel-item"
                                >
                                    {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.INVOICE}
                                    <NavigateNextIcon />
                                </div>
                            )}
                            {this.props.order.cancel_order_enabled &&
                                (this.props.order.cancel_order_items_enabled ? (
                                    <div
                                        onClick={this.handleCancelOrderItemsClick.bind(this)}
                                        className="layout horizontal center justified order-menu-button-panel-item"
                                    >
                                        {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.CANCEL_ITEMS}
                                        <NavigateNextIcon />
                                    </div>
                                ) : (
                                    <div
                                        onClick={this.handleCancelOrderClick.bind(this)}
                                        className="layout horizontal center justified order-menu-button-panel-item"
                                    >
                                        {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.CANCEL_ORDER}
                                        <NavigateNextIcon />
                                    </div>
                                ))}
                            {this.props.order.return_order_enabled &&
                                (this.props.order.return_order_items_enabled ? (
                                    <div
                                        onClick={this.handleReturnOrderItemsClick.bind(this)}
                                        className="layout horizontal center justified order-menu-button-panel-item"
                                    >
                                        {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.RETURN_ITEMS}
                                        <NavigateNextIcon />
                                    </div>
                                ) : (
                                    <div
                                        onClick={this.handleReturnOrderClick.bind(this)}
                                        className="layout horizontal center justified order-menu-button-panel-item"
                                    >
                                        {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.RETURN_ORDER}
                                        <NavigateNextIcon />
                                    </div>
                                ))}
                            {/* {this.props.order.replace_order_items_enabled && (
                                    <div
                                        onClick={this.handleReplaceOrderItemsClick.bind(this)}
                                        className="layout horizontal center justified order-menu-button-panel-item"
                                    >
                                        {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.REPLACE_ITEMS}
                                        <NavigateNextIcon />
                                    </div>
                                )} */}
                            <div
                                onClick={this.handleRequestAssistanceClick.bind(this)}
                                className="layout horizontal center justified order-menu-button-panel-item"
                            >
                                {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.REQUEST_ASSISTANCE}
                                <NavigateNextIcon />
                            </div>
                            {this.props.order.egift_cards && this.props.order.egift_cards.length > 0 && (
                                <div
                                    onClick={this.handleSendEgiftcardsEmailClick.bind(this)}
                                    className="layout horizontal center justified order-menu-button-panel-item"
                                >
                                    {locales[this.props.store[0]][this.props.language].ORDER_PAGE.MENU.SEND_EGIFTCARDS_EMAIL}
                                    <NavigateNextIcon />
                                </div>
                            )}
                        </div>
                        <InvoiceWindow
                            open={this.state.invoice_window_open}
                            order_id={this.props.match.params.order_id}
                            handleCloseInvoiceDialog={this.handleCloseInvoiceDialog.bind(this)}
                        />
                        {this.props.order.cancel_order_enabled &&
                            (this.props.order.cancel_order_items_enabled ? (
                                <CancelOrderItemsWindow
                                    order={this.props.order}
                                    open={this.state.cancel_items_window_open}
                                    order_id={this.props.match.params.order_id}
                                    handleClose={this.handleCloseCancelOrderItemsDialog.bind(this)}
                                    refreshOrder={this.refreshOrder.bind(this)}
                                    total_egift_cards={this.props.order.egift_cards !== null ? this.props.order.egift_cards.length : 0}
                                />
                            ) : (
                                <CancelOrderWindow
                                    order={this.props.order}
                                    open={this.state.cancel_order_window_open}
                                    order_id={this.props.match.params.order_id}
                                    handleClose={this.handleCloseCancelOrderDialog.bind(this)}
                                    refreshOrder={this.refreshOrder.bind(this)}
                                    total_egift_cards={this.props.order.egift_cards !== null ? this.props.order.egift_cards.length : 0}
                                />
                            ))}
                        {this.props.order.return_order_enabled &&
                            (this.props.order.return_order_items_enabled ? (
                                <ReturnOrderItemsWindow
                                    order={this.props.order}
                                    open={this.state.return_items_window_open}
                                    order_id={this.props.match.params.order_id}
                                    handleClose={this.handleCloseReturnOrderItemsDialog.bind(this)}
                                    total_egift_cards={this.props.order.egift_cards !== null ? this.props.order.egift_cards.length : 0}
                                />
                            ) : (
                                <ReturnOrderWindow
                                    order={this.props.order}
                                    open={this.state.return_order_window_open}
                                    order_id={this.props.match.params.order_id}
                                    handleClose={this.handleCloseReturnOrderDialog.bind(this)}
                                    total_egift_cards={this.props.order.egift_cards !== null ? this.props.order.egift_cards.length : 0}
                                />
                            ))}
                        {/* {this.props.order.replace_order_items_enabled && (
                            <ReplaceOrderItemsWindow
                                order={this.props.order}
                                open={this.state.replace_items_window_open}
                                order_id={this.props.match.params.order_id}
                                handleClose={this.handleCloseReplaceOrderItemsDialog.bind(this)}
                            />
                        )} */}
                        <EgiftCardsEmailWindow
                            open={this.state.egiftcards_email_window_open}
                            order_id={this.props.match.params.order_id}
                            handleCloseEgiftCardsEmailDialog={this.handleCloseEgiftCardsEmailDialog.bind(this)}
                        />
                    </div>
                )}
            </section>
        );
    }
}

export default withRouter(Order);



// WEBPACK FOOTER //
// ./src/views/Order/components/Order.jsx